var ChangeQuantity = function (param) {

    const ArtworkKeyCart = param.parentNode.dataset.artwork_key;
    const FrameKeyCart = param.parentNode.dataset.frame_key;

    let QuantityInput;
    let formData;
    if (param.getAttribute('name') == "plus-custom"){
        QuantityInput = parseInt(param.parentNode.querySelector('input').value) + 1;
    } else if (param.getAttribute('name') == "minus-custom") {
        QuantityInput = parseInt(param.parentNode.querySelector('input').value) - 1;
    }

    param.parentNode.querySelector('.quantity-number').innerHTML = QuantityInput;

    if (FrameKeyCart == "-"){
        formData = {
            updates: {
                [ArtworkKeyCart]: QuantityInput
            }
        };
    } else {
        formData = {
            updates: {
                [ArtworkKeyCart]: QuantityInput,
                [FrameKeyCart]: QuantityInput
            }
        };
    }
        
 

        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
            window.location.href = '/cart';
        })

        .catch(function (err) {

        });


}

var RemoveFrame = function (param) {
    const ArtworkKeyCart = param.dataset.artwork_key;
    const FrameKeyCart = param.dataset.frame_key;
    const ArtworkIdCart = param.dataset.artwork_id;
    const ArtworkQuantityCart = parseInt(param.dataset.artwork_quantity);
    const FrameQuantityCart = parseInt(param.dataset.frame_quantity) - 1;

    //remove frame and artwork
        let formData = {
            updates: {
                [ArtworkKeyCart]: 0,
                [FrameKeyCart]: 0
            }
        };

        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(function (response) {
            if (response.status === 200) {
                ajaxReAddProduct()
            }
        })
        .then(data => {
            
        })
        .catch(function (err) {

        });
    


    var addData = {
        items: [
            {
                id: ArtworkIdCart,
                quantity: ArtworkQuantityCart,
            }
        ]
    };

    function ajaxReAddProduct() {
        console.log('next')
        fetch('/cart/add.js', {
            body: JSON.stringify(addData),
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest'
            },
            method: 'POST'
        }).then(function (response) {
            if (response.status === 200) {
                window.location.href = '/cart';
            }
            return response.json();
        }).then(function (json) {

        }).catch(function (err) {
        });
    }

};


var RemoveFrameAll = function (param) {
    const ArtworkKeyCart = param.dataset.artwork_key;
    const FrameKeyCart = param.dataset.frame_key;

    //remove frame and artwork
    function ajax(callback) {
        let formData = {
            updates: {
                [ArtworkKeyCart]: 0,
                [FrameKeyCart]: 0
            }
        };

        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
            callback(data);
        })

        .catch(function (err) {

        });
    };


    ajax(function () {
        window.location.href = '/cart';
    })

}